import { AGENT_IDS, DATA_CATALOG_API_TOOL_IDS } from '@/app/data-catalog/_common/constants'
import { useApiRequest } from '@/lib/http-utils'
import { useMutation } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'

export type TableClearRequest = {
  table_name: string
  clear_table_description: boolean
  clear_column_metadata: boolean
  clear_column_tags: boolean
}

export type MetadataClearRequest = {
  service_name: string
  database_name: string
  schema_name: string
  tables: TableClearRequest[]
}

export type ClearedTable = {
  table_name: string
  description_cleared: boolean
  cleared_columns: string[]
}

export type ClearMetadataResponse = {
  success: boolean
  cleared_tables: ClearedTable[]
  failed_tables: string[]
}

export type ClearMetadataParams = {
  service_name: string
  database_name: string
  schema_name: string
  tables: TableClearRequest[]
}

export function useClearMetadataMutation() {
  const agentId = AGENT_IDS.DATA_CATALOG_AGENT
  const { apiRequest, domainId } = useApiRequest()

  return useMutation<{ output: ClearMetadataResponse }, Error, ClearMetadataParams>({
    mutationFn: async (params) => {
      const basePath = taskManagerApiPaths.agentById({ domainId, agentId })
      const payload = {
        metadataClearRequest: {
          service_name: params.service_name,
          database_name: params.database_name,
          schema_name: params.schema_name,
          tables: params.tables,
        },
      }

      const response = await apiRequest({
        path: basePath,
        queryParams: {
          tool_id: DATA_CATALOG_API_TOOL_IDS.CLEAR_METADATA,
        },
        options: {
          method: 'POST',
          body: JSON.stringify(payload),
        },
      })

      const json = (await response.json()) as { output: ClearMetadataResponse }
      return json
    },
  })
}
